module.exports = __webpack_public_path__ + "static/nxrt-esports4-2-1fe0935f0aebc81d038ba9dd6c541d8c.jpg";